module.exports = __webpack_public_path__ + "static/3-bf947ed7d0e3f089c51cd2bf2e4bb856.jpg";